import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
const notyf = new Notyf({ duration: 7000, position: { x: 'right', y: 'bottom' } });


export const fetchProjects = createAsyncThunk('constructionProjects/fetchProjects', async (token) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/construction_projects`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        const result = await response.json();
        notyf.success('Construction projects loaded successfully.');
        return result.constructionProjects;
    } catch (error) {
        console.error('Error fetching services:', error);
    }
});


//!fetch actions:
const constructionProjectsSlice = createSlice({
    name: 'constructionProjects',
    initialState: {
        constructionProjects: null,
        status: 'idle',
        error: null,   
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProjects.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProjects.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.constructionProjects = action.payload;
            })
            .addCase(fetchProjects.rejected, (state, action) => {
                state.status = 'failed';
                state.errorAdd = action.error.message;
            })
            
    },
});
export const constructionProjectsReducer= constructionProjectsSlice.reducer;
